import React, { useState } from 'react';
import moment from 'moment';
import createpic from '../../../assets/images/addchanneling.svg'
import { useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css';
import { POST } from '../../../helpers/httphelper';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { storage } from '../../../helpers/Firebase';
import { toast as superToast } from 'bulma-toast';
function AddChanneling(props) {
    const userid = localStorage.getItem("user")
    const [show, setShow] = useState(false)
    const [today, setToday] = useState(false)
    const [date, setDate] = useState('')
    const [time, setTime] = useState('')
    const [doctorName, setDoctorName] = useState('')
    const [visitCity, setVisitCity] = useState('')
    const [reason, setReason] = useState('')
    const [feedback, setFeedback] = useState('')
    const [FileUrl, setFileUrl] = useState('')
    const [Progress, setProgress] = useState(0)
    let navigate = useNavigate();
    const checkDate = (date) => {
        setDate(date)
        var selectDate = moment(date, "YYYY-MM-DD")
        var todayDate = moment().startOf('day')
        var days = moment.duration(selectDate.diff(todayDate)).asDays()
        if (days < 0) {
            setShow(true)
        }
        else if (days === 0) {
            setToday(true)
        }
        else {
            setShow(false)
        }
    }




    const checkTime = (time) => {
        setTime(time)
        if (today) {
            const selectTime = moment(time, "HH:mm")
            const todayTime = moment().startOf('minute')
            const mins = moment.duration(selectTime.diff(todayTime)).asMinutes()
            if (mins < 0) {
                setShow(true)
            }
            else {
                setShow(false)
            }
        }
    }

    const sendData = (e) => {
        e.preventDefault()
        console.log("s")
        const channeling = {
            date,
            time,
            doctorName,
            visitCity,
            reason,
            feedback,
            pimage: FileUrl,
            userid
        }
        POST('api/channeling/create', channeling).then(data => {
            console.log(data)
            superToast({
                message: "Created Successfully",
                type: 'is-success',
                dismissible: true,
                position: "top-center",
                animate: { in: 'fadeIn', out: 'fadeOut' },
            })
            navigate("/channeling")


        }).catch(err => {
            console.log(err)
        })
    }

    const uploadImage = (e) => {
        e.preventDefault()
        const file = e.target.files[0]
        if (!file) {
            return
        }
        const storageRef = ref(storage, `/channelings/${file.name}`); //get file reference
        const uploadTask = uploadBytesResumable(storageRef, file); //upload file

        uploadTask.on("state_changed", (snapshot) => { //listen for state changes
            const prog = Math.round( //get progress percentage
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100 //calculate progress percentage
            ); //end get progress percentage
            setProgress(prog); //set progress
        }, (err) => {
            console.log(err);
        }, () => {
            getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                setFileUrl(url);
                console.log(url);
            })
        })

    }

    return (
        <div className='container'>
            <div className='columns'>
                <div className='column is-6 mt-6'>
                    <img src={createpic} alt="i" />
                </div>
                <div className={show ? 'column is-6 mt-2' : 'column is-6 mt-6'}>
                    <form onSubmit={sendData}>
                        <h1 className='title is-2 has-text-centered'>Add Channeling</h1>
                        <div className='columns is-justify-content-center is-mobile  mb-0'>
                            <div className='column is-5 '>
                                <div className="field">
                                    <label className="label">Channeling Date</label>
                                    <div className="control">
                                        <input required className="input is-info" onChange={(e) => { checkDate(e.target.value) }} type="date" />
                                    </div>
                                </div>
                            </div>

                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Channeling Time</label>
                                    <div className="control">
                                        <input required className="input is-info" onChange={(e) => { checkTime(e.target.value) }} type="time" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Doctor Name</label>
                                    <div className="control">
                                        <input required className="input is-info" onChange={(e) => { setDoctorName(e.target.value) }} type="text" placeholder='Doctor Name' />
                                    </div>
                                </div>
                            </div>



                            <div className='column is-5'>
                                <div className="field">
                                    <label className="label">Visiting City</label>
                                    <div className="control">
                                        <input required className="input is-info" onChange={(e) => { setVisitCity(e.target.value) }} type="text" placeholder='Visiting City' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='columns is-justify-content-center is-mobile mb-0'>
                            <div className='column is-10'>
                                <div className="field">
                                    <label className="label">Reason</label>
                                    <div className="control">
                                        <input required className="input is-info" onChange={(e) => { setReason(e.target.value) }} type="text" placeholder='Reason' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {(show ? <>
                            <div className='columns is-justify-content-center is-mobile mb-0'>
                                <div className='column is-10'>
                                    <div className="field">
                                        <label className="label">Prescription Slip</label>
                                        <div className="control">
                                            <input onChange={(e) => { uploadImage(e) }} className="input is-info" type="file" placeholder='Reason' />
                                        </div>
                                    </div>
                                    <div className="progressText">
                                        <progress style={{ height: '4px' }} className="progress is-success" value={Progress} max="100">{Progress}</progress>
                                    </div>
                                </div>
                            </div>

                            <div className='columns is-justify-content-center is-mobile mb-0'>
                                <div className='column is-10'>
                                    <div className="field">
                                        <label className="label">Doctor Feedback</label>
                                        <div className="control">
                                            <input className="input is-info" onChange={(e) => { setFeedback(e.target.value) }} type="input" placeholder='Feedback' />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </> : <></>)}


                        <h1 className='has-text-centered'><input type='submit' value='Create' className='button is-info' /></h1>
                    </form>
                </div>
            </div>
        </div >
    );
}

export default AddChanneling;